import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import Box from '@mui/material/Box'
import Tab from '@mui/material/Tab'
import dayjs from 'dayjs'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import api from '../../../../api'
import Responsive from '../../../../assets/config/Responsive'
import DoubleRightIcon from '../../../../assets/icons/JSX/DoubleRightIcon'
import FailIcon from '../../../../assets/icons/JSX/FailIcon'
import Colors from '../../../../assets/styles/Colors'
import Accordion from '../../../../components/Accordion'
import DownloadButton from '../../../../components/DownloadButton'
import Loader from '../../../../components/Loader'
import NotFound404 from '../../../../components/NotFound404'
import PayButton from '../../../../components/PayButton'
import TrashButton from '../../../../components/TrashButton'
import DeleteModal from '../../../../components/modals/DeleteModal'
import PendingPayModal from '../../../../components/modals/PendingPayModal'
import Button from '../../../../components/v2/buttons/Button'
import { useAppSelector } from '../../../../store'
import PendingPayments from '../../payment/PendingPayments'
import PolicyTransactions from '../../payment/transactions/PolicyTransactions'
import { currencySymbol, georgianFormatter } from '../../../../domain/types'
import axios from 'axios'
import { saveAs } from 'file-saver'
import { AppState } from '../../../../store/appSlice'

const TravelPolicyDetail = () => {
  const { t } = useTranslation()
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  const { policyId: policyIdStr = '0' } = useParams()
  const policyId = parseInt(policyIdStr)

  const [activeTab, setActiveTab] = React.useState('1')
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue)
  }

  const { data: policyDetail, isFetching: isPolicyDetailLoading, refetch: policyDetailRefetch } = api.useGetUserCurrentPoliciesQuery(policyId)

  const discount = policyDetail?.mainPolicy?.orderItems?.[0]?.order?.discount

  const downloadPdf = (event: Event, url?: string) => {
    event?.stopPropagation()
    if (url) {
      const fileName = url?.split('frani.com/')?.[1] || 'file name not found'
      axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/pdf',
        },
      })
        .then((response) => {
          const pdfBlob = new Blob([response.data], { type: 'application/pdf' })
          saveAs(pdfBlob, fileName)
        })
        .catch((error) => {
          toast.error('ფაილის ჩამოტვირთვისას მოხდა შეცდომა:', error)
        })
    }
  }

  const [deletePendingPolicy, { isLoading: isDeletePendingPolicyLoading }] = api.useDeleteUserPendingPolicyMutation()

  const deleteSelectedPendingPolicy = async () => {
    try {
      await deletePendingPolicy(policyId).unwrap()
    } catch (error: any) {
      if (error?.data?.errors?.constructor === Array) {
        const firstError = error.data.errors[0]
        const errorMessage = firstError.message
        toast.error(errorMessage)
      } else {
        toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (deleteSelectedPendingPolicy)')
      }
    }
    window.location.href = '/my-policies'
  }

  const [openDialogModal, setOpenDialogModal] = useState<boolean>(false)

  const _onCloseDialogMOdal = () => {
    setOpenDialogModal(false)
  }

  const [createOrder, { data: createPendingNewOrder, isLoading: isCreatePendingNewOrderLoading }] =
    api.useCreateUserPendingNewOrderMutation()

  const paySelectedPendingPolicies = async () => {
    try {
      const response = await createOrder({
        policyIds: [policyId],
        targetType: policyDetail?.mainPolicy?.targetType,
      }).unwrap()
      if ('orderItems' in response) {
        setOpenDialogModal(true)
        // 
        policyDetailRefetch()
      } else {
        toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (paySelectedPendingPolicies) (102)')
      }
    } catch (error: any) {
      if (error?.data?.errors?.constructor === Array) {
        const firstError = error.data.errors[0]
        const errorMessage = firstError.message
        toast.error(errorMessage)
      } else {
        toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (paySelectedPendingPolicies) (110)')
      }
    }
  }
  const companyName = createPendingNewOrder?.orderItems[0]?.company?.[lang]?.title
  const amount = createPendingNewOrder?.orderItems[0]?.eachPrice
  const insuranceType = createPendingNewOrder?.orderItems[0].category?.[lang]?.title
  const orderSingleInfo = {
    companyName: companyName,
    amount: amount,
    insuranceType: insuranceType,
  }
  const orderModalInfo = [orderSingleInfo]

  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false)

  const _onCloseDeleteModal = () => {
    setOpenDeleteModal(false)
  }

  const [openPendingPayments, setOpenPendingPayments] = useState<boolean>(false)

  const orderId = createPendingNewOrder?.order?.id
  const totalPrice = createPendingNewOrder?.order?.totalPrice
  const discountUsed = createPendingNewOrder?.order?.discounted
  const validPromoCode = createPendingNewOrder?.order?.validPromoCode
  const orderInfo = {
    orderId: orderId,
    totalPrice: totalPrice,
    category: ['travel-outside-georgia'],
    discountUsed: discountUsed,
    validPromoCode: validPromoCode
  }

  //
  const parsedWordingFileUrl = policyDetail?.mainPolicy?.productWordingUrl?.includes('translations')
    ? JSON.parse(policyDetail?.mainPolicy?.productWordingUrl)
    : ''
  //

  const isMainLoading = isPolicyDetailLoading || isDeletePendingPolicyLoading || isCreatePendingNewOrderLoading
  return isMainLoading ? (
    <Loader />
  ) : !policyDetail ? (
    <NotFound404 />
  ) : openPendingPayments ? (
    <PendingPayments orderInfo={orderInfo} />
  ) : (
    <Wrapper>
      <>
        <MuiBox>
          <TabContext value={activeTab}>
            <BoxStyle>
              <MuiTabList onChange={handleChange} aria-label="lab API tabs example">
                <MuiTab label={t('inDetails')} value="1"></MuiTab>
                <MuiTab label={t('transactions')} value="2" />
              </MuiTabList>
              {policyDetail?.mainPolicy?.status?.toLowerCase() === 'active' ||
              policyDetail?.mainPolicy?.status?.toLowerCase() === 'closed' ? (
                <>
                  {activeTab === '1' ? (
                    <Div>
                      <DownloadButton
                        style={{ marginLeft: 'auto' }}
                        onClick={(event) => downloadPdf(event, policyDetail.mainPolicy.policyPdfUrl)}
                      />
                    </Div>
                  ) : null}
                </>
              ) : (
                <>
                  {activeTab === '1' ? (
                    <Btns>
                      <PayButton
                        text="Pay"
                        onClick={() => {
                          paySelectedPendingPolicies()
                        }}
                      />
                      <TrashButton onClick={() => setOpenDeleteModal(true)} />
                    </Btns>
                  ) : null}
                </>
              )}
            </BoxStyle>
            <MuiTabPanel value="1">
              <div>
                <AccordionWrapper>
                  <Accordion title={t('policyInfo')} openAccordion={true}>
                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('insuranceCompany')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {policyDetail?.mainPolicy?.package?.product?.company?.title}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('carCategory')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {policyDetail?.mainPolicy?.targetType === 'TravelPolicy' && lang === 'ge'
                          ? 'სამოგზაურო'
                          : policyDetail?.mainPolicy?.targetType}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('policyNumber')}</OffetTextLeftSide>
                      <OffetTextRightSide>{policyDetail?.mainPolicy?.policyNumber}</OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('policyType')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {(policyDetail?.travelType?.toLowerCase() === 'single' && lang === 'ge' && 'ერთჯერადი') ||
                          (policyDetail?.travelType?.toLowerCase() === 'single' && lang === 'en' && 'single') ||
                          (policyDetail?.travelType?.toLowerCase() === 'multi' && lang === 'ge' && 'მრავალჯერადი') ||
                          (policyDetail?.travelType?.toLowerCase() === 'multi' && lang === 'en' && 'multi')}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('startDate')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {dayjs(policyDetail?.mainPolicy?.startDate).format('DD MMMM YYYY')}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('endDate')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {dayjs(policyDetail?.mainPolicy?.endDate).format('DD MMMM YYYY')}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('numberOfDays')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {policyDetail?.insuranceDays} {t('day')}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('travelArea')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {policyDetail?.area?.toLowerCase() === 'world' && lang === 'ge'
                          ? 'მსოფლიო'
                          : policyDetail?.area?.toLowerCase() === 'europe' && lang === 'ge'
                          ? 'ევროპა'
                          : policyDetail?.area?.toLowerCase() === 'schengen' && lang === 'ge'
                          ? 'შენგენი'
                          : policyDetail?.area?.toLowerCase()}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('limit')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {policyDetail?.mainPolicy?.compensationLimit}{' '}
                        {currencySymbol(policyDetail?.mainPolicy?.compensationCurrency)}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('franchise')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {policyDetail?.mainPolicy?.franchise}{' '}
                        {currencySymbol(policyDetail?.mainPolicy?.compensationCurrency)}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('policePrice')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {' '}
                        {`${georgianFormatter.format(policyDetail?.eachPrice)} ₾`}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    {discount !== null && (discount?.promoCode?.applyingDiscount?.days ? discount?.promoCode?.applyingDiscount?.policyId === policyDetail?.mainPolicy?.id : true) && (
                      <>
                        <CheckInfoTextBox>
                          <OffetTextLeftSide>{t('promoCode')}</OffetTextLeftSide>
                          <OffetTextRightSide>{discount?.promoCode?.code}</OffetTextRightSide>
                        </CheckInfoTextBox>
                      </>
                    )}

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('releaseDate')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {dayjs(policyDetail?.mainPolicy?.updatedAt).format('DD MMMM YYYY | HH:mm')}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('status')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {lang === 'ge' && policyDetail?.mainPolicy?.status?.toLowerCase() === 'active'
                          ? 'აქტიური'
                          : lang === 'ge' && policyDetail?.mainPolicy?.status?.toLowerCase() === 'pending'
                          ? 'მომლოდინე'
                          : policyDetail?.mainPolicy?.status}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>
                  </Accordion>
                  <Accordion title={t('travelerInformation')} openAccordion={false}>
                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('firstName')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {policyDetail?.mainPolicy?.firstName || policyDetail?.mainPolicy?.translations?.en?.firstName}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('lastName')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {policyDetail?.mainPolicy?.lastName || policyDetail?.mainPolicy?.translations?.en?.lastName}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('birthDay')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {dayjs(policyDetail?.mainPolicy?.birthday).format('DD MMMM YYYY')}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('personalNumber')}</OffetTextLeftSide>
                      <OffetTextRightSide>{policyDetail?.personalNumber}</OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('passportNumber')}</OffetTextLeftSide>
                      <OffetTextRightSide>{policyDetail?.passportNumber}</OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('gender')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        {policyDetail?.gender === 'female' && lang === 'ge'
                          ? 'ქალი'
                          : policyDetail?.gender === 'male' && lang === 'ge'
                          ? 'კაცი'
                          : policyDetail?.gender}
                      </OffetTextRightSide>
                    </CheckInfoTextBox>
                  </Accordion>
                  {(policyDetail && policyDetail.attachedAddons && policyDetail.attachedAddons.length >= 1) ||
                  (policyDetail && policyDetail.grouppedAddons && policyDetail.grouppedAddons.length >= 1) ? (
                    <Accordion title={t('additionalCoverages')} openAccordion={false}>
                      {policyDetail &&
                        policyDetail.attachedAddons &&
                        policyDetail.attachedAddons?.map((item, index) => (
                          <CheckInfoTextBox key={index}>
                            <OffetTextLeftSide>{item.title}</OffetTextLeftSide>
                            <OffetTextRightSide>{item.price} ₾</OffetTextRightSide>
                          </CheckInfoTextBox>
                        ))}
                      {policyDetail &&
                        policyDetail.grouppedAddons &&
                        policyDetail.grouppedAddons?.map((item, index) => (
                          <CheckInfoTextBox key={index}>
                            <OffetTextLeftSide>{item.title}</OffetTextLeftSide>
                            <OffetTextRightSide>{item.price} ₾</OffetTextRightSide>
                          </CheckInfoTextBox>
                        ))}
                    </Accordion>
                  ) : null}
                  {policyDetail.mainPolicy &&
                  policyDetail.mainPolicy?.package?.travelAttachedRisks &&
                  policyDetail.mainPolicy?.package?.travelAttachedRisks?.length < 1 ? null : (
                    <Accordion title={t('whatIsCovered')} openAccordion={false}>
                      {policyDetail.mainPolicy?.package?.travelAttachedRisks?.map((item, index) => (
                        <CheckInfoTextBox key={index}>
                          <OffetTextLeftSide>{item?.risk?.translations[lang]?.riskName}</OffetTextLeftSide>
                          <OffetTextRightSide>{item?.translations[lang]?.riskDescription}</OffetTextRightSide>
                        </CheckInfoTextBox>
                      ))}
                    </Accordion>
                  )}
                  {policyDetail.mainPolicy &&
                  policyDetail.mainPolicy?.package?.insuranceExceptions?.length < 1 ? null : (
                    <Accordion title={t('notCovered')} openAccordion={false}>
                      <InsuranceExceptionsBlock>
                        {policyDetail.mainPolicy?.package?.insuranceExceptions?.map((item, index) => (
                          <MessageText key={index}>
                            <DoubleRightIcon /> <span>{item?.translations?.[lang]?.title}</span>
                          </MessageText>
                        ))}
                      </InsuranceExceptionsBlock>
                    </Accordion>
                  )}
                  <Accordion title={t('documents')} openAccordion={false}>
                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('insuranceContract')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        <CustomATag
                          href={
                            policyDetail?.mainPolicy?.productWordingUrl?.includes('translations')
                              ? parsedWordingFileUrl?.translations?.[lang]?.url
                              : policyDetail?.mainPolicy?.productWordingUrl
                          }
                          target={'_blank'}
                        >
                          {policyDetail?.mainPolicy?.productWordingUrl?.includes('translations')
                            ? parsedWordingFileUrl?.translations?.[lang]?.url
                            : policyDetail?.mainPolicy?.productWordingUrl}
                        </CustomATag>
                      </OffetTextRightSide>
                    </CheckInfoTextBox>

                    <CheckInfoTextBox>
                      <OffetTextLeftSide>{t('policyContract')}</OffetTextLeftSide>
                      <OffetTextRightSide>
                        <CustomATag href={policyDetail?.mainPolicy?.policyPdfUrl} target={'_blank'}>
                          {policyDetail?.mainPolicy?.policyPdfUrl}
                        </CustomATag>
                      </OffetTextRightSide>
                    </CheckInfoTextBox>
                  </Accordion>
                </AccordionWrapper>
                {
                  <PendingPayModal
                    onClick={() => setOpenPendingPayments(true)}
                    onClose={_onCloseDialogMOdal}
                    isOpen={openDialogModal}
                    orderModalInfo={orderModalInfo}
                    orderInfo={orderInfo}
                  >
                    {t('paymentDetails')}
                  </PendingPayModal>
                }
                {
                  <DeleteModal onClose={_onCloseDeleteModal} isOpen={openDeleteModal}>
                    <ModalItems>
                      <FailIcon />
                      <ModalText>{t('areYouSureYouWantToDelete')}</ModalText>
                      <Button onClick={deleteSelectedPendingPolicy} text={t('yesDelete')} fullWidth />
                      <Button
                        onClick={_onCloseDeleteModal}
                        text={t('cancel')}
                        buttonType="transparent"
                        style={{ border: 'none', marginTop: '10px' }}
                        fullWidth
                      />
                    </ModalItems>
                  </DeleteModal>
                }
              </div>
            </MuiTabPanel>
            <MuiTabPanel value="2">
              <PolicyTransactions policyId={policyId} />
            </MuiTabPanel>
          </TabContext>
        </MuiBox>
      </>
    </Wrapper>
  )
}
const Div = styled.div`
  display: block;
  margin-left: auto;
  cursor: pointer;
  ${Responsive.mobile} {
    display: flex;
    margin-block: 24px;
  }
`
const InsuranceExceptionsBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`
const MessageText = styled.div`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0px;
  }

  span {
    margin-left: 15px;
    color: ${Colors.primaryGrey};
  }

  svg {
    min-width: 20px;
    width: 20px;
    height: 20px;
    margin-left: -3px;
    color: ${Colors.primaryGrey};
  }

  /*  */
  ${Responsive.mobile} {
    /* message checkmark icon & svg */
    svg {
      margin-left: 0px;
      min-width: 15px;
      width: 15px;
    }

    span {
      margin-left: 20px;
      color: ${Colors.primaryGrey};
      line-height: 20px;
    }
  }
`
const CustomATag = styled.a`
  display: inline-block;
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration-color: ${Colors.primaryRed};
  color: ${Colors.primaryBlack};
  &:hover {
    color: ${Colors.primaryBlack};
    opacity: 0.9;
  }
`
const MuiTabList = styled(TabList)`
  button {
    padding: 0px;
    margin-right: 60px;
    font-size: 18px;
    text-transform: none;

    &:last-child {
      margin-right: 0px;
    }
  }

  .MuiTabs-indicator {
    background-color: ${Colors.primaryBlack} !important;
  }

  .MuiTouchRipple-root {
    display: none !important;
  }
  ${Responsive.mobile} {
    button {
      margin-right: auto;
      font-size: 13px;
    }
  }
`
const MuiTab = styled(Tab)`
  color: ${Colors.primaryBlack} !important;
`
const MuiTabPanel = styled(TabPanel)`
  padding: 0px !important;
  margin-top: 45px;
  ${Responsive.mobile} {
    margin-top: 20px;
  }
`
const MuiBox = styled(Box)``
const BoxStyle = styled(Box)`
  display: flex;
  ${Responsive.mobile} {
    display: block;
  }
`
const Wrapper = styled.div`
  height: 100%;
  .MuiButtonBase-root {
    font-family: inherit;
  }
`

const OffetTextLeftSide = styled.span`
  color: ${Colors.primaryGrey};
  font-size: 14px;
`
const OffetTextRightSide = styled.span`
  color: ${Colors.primaryBlack};
  font-size: 14px;
`

const AccordionWrapper = styled.div``
const CheckInfoTextBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 15px;
  gap: 30px;

  &:last-child {
    margin-bottom: 0px;
  }

  ${OffetTextRightSide} {
    text-align: right;
  }

  ${Responsive.mobile} {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;

    ${OffetTextRightSide} {
      text-align: left;
    }
  }
`

const Btns = styled.div`
  display: flex;
  margin-left: auto;
  ${Responsive.mobile} {
    margin-block: 24px;
  }
`
const ModalItems = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 50px 30px;
  ${Responsive.mobile} {
    padding: 0px;
  }
`
const ModalText = styled.div`
  margin-top: 40px;
  margin-bottom: 30px;
  font-size: 18px;
  color: ${Colors.primaryBlack};
`

export default TravelPolicyDetail
